export const CROSS_CHECK_TYPE = {
  COD: 1,
  FEE: 2,
  COMPARE_FEE: 3,
  FEE1: 4
}



// WEBPACK FOOTER //
// ./src/constants/index.js